<template>
  <div class="icon icon-filters" v-html="IconFilters"></div>
</template>

<script>
import IconFilters from './icon-filters.svg'
export default {
  data () {
    return {
      IconFilters: IconFilters
    }
  }
}
</script>
<style lang='scss'>
.icon-filters{
  svg{
    .f-a,.f-c,.f-f,.f-h{
      fill:none;
    }
    .f-a{
      stroke:#707070;
    }
    .f-b,.f-c,.f-f{
      stroke:#000;
    }
    .f-b,.f-c{
      stroke-width:1.5px;
    }
    .f-c,.f-f{
      stroke-linecap:round;
    }
    .f-c{
      stroke-dasharray:2 4;
    }
    .f-d{
      fill:#fff;
      stroke:#fff;
    }
    .f-e{
      clip-path:url(#a);
    }
    .f-g{
      stroke:none;
    }
  }
  &.selected{
    svg{
      .f-b,.f-c,.f-f{
        stroke:#0000FF;
      }
      .f-b .f-h{
        fill: #0000FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/IconFilters.vue